module.exports = __webpack_public_path__ + "fonts/899f008.ttf";